<template>
    <div class="pageBox">
        <PageComponent publicTemplateName="访问后未达到填报标准单位数的应训人员" :publicStatus="2300"></PageComponent>
    </div>
</template>

<script>
import PageComponent from "./PageComponent"
export default {
    components: {PageComponent},
    data() {
        return{
            
        }
    },
    methods: {
        
    },
    watch: {
        
    },
    mounted() {
        
    },
}
</script>

<style lang="stylus" scoped>
    
</style>